import { useTransition } from "react";
import { toast } from "sonner";
import { Icone } from "@/components/Icone";
import { marcarPresencaAction } from "@/web/src/acoes";

type Presenca = "compareceu" | "faltou" | null;

/**
 * O último elo do funil, e o único que uma pessoa precisa fechar à mão: o
 * agente sabe que marcou, mas não tem como saber se a pessoa foi.
 *
 * Clicar de novo no mesmo botão desfaz — quem errou o clique precisa poder
 * voltar sem abrir o Google Agenda na mão.
 */
export function BotoesPresenca({ eventoId, presenca }: { eventoId: string; presenca: Presenca }) {
  const [pendente, iniciar] = useTransition();

  function marcar(op: Exclude<Presenca, null>) {
    const novo = presenca === op ? null : op;
    iniciar(async () => {
      const r = await marcarPresencaAction(eventoId, novo);
      if (!r.ok) toast.error(r.erro);
    });
  }

  return (
    <div className="flex shrink-0 items-center gap-1.5" role="group" aria-label="Presença">
      {(["compareceu", "faltou"] as const).map((op) => {
        const ativo = presenca === op;
        return (
          <button
            key={op}
            type="button"
            onClick={() => marcar(op)}
            disabled={pendente}
            title={ativo ? "Clique para desfazer" : undefined}
            aria-pressed={ativo}
            className={`flex h-8 items-center gap-1.5 rounded-full px-3 text-[13px] font-semibold transition-colors disabled:opacity-40 ${
              ativo
                ? op === "compareceu"
                  ? "bg-[var(--color-marca)] text-[var(--color-sobre-marca)]"
                  : "bg-[var(--color-atencao-fundo)] text-[var(--color-atencao)]"
                : "bg-[var(--color-cartao)] text-[var(--color-tinta)] shadow-botao hover:bg-[var(--color-painel)]"
            }`}
          >
            <Icone nome={op === "compareceu" ? "check" : "fechar"} className="h-4 w-4" />
            {op === "compareceu" ? "Compareceu" : "Faltou"}
          </button>
        );
      })}
    </div>
  );
}
